import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface ProjectForPrint {
  id: string;
  name: string;
  project_code: string | null;
  created_at: string;
}

/**
 * VIB-675/VIB-647: minimal projects-read for StatisterPrintPage.
 * Vi henter kun feltene som vises i header (navn, project_code, created_at)
 * for å holde print-rendringen rask. Eget query-key så cachen ikke kolliderer
 * med use-project-detail som henter mye mer.
 */
export function useProjectForPrint(projectId: string | undefined) {
  return useQuery({
    queryKey: ["project-print", projectId],
    enabled: !!projectId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("projects")
        .select("id, name, project_code, created_at")
        .eq("id", projectId!)
        .is("deleted_at", null)
        .single();
      if (error) throw error;
      return data as ProjectForPrint;
    },
  });
}
